import { StoreState } from "..";

export const getAriaLive = (state: StoreState) => state.ariaLive;
